// extracted by mini-css-extract-plugin
module.exports = {"root":"item__3PiPezKg","icon":"item_icon__3PiPezKg"};